import React from 'react'

const IconFileText = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9z' />
         <polyline points='14 3 14 9 19 9' />
         <line x1='8.5' y1='13' x2='15.5' y2='13' />
         <line x1='8.5' y1='17' x2='13.5' y2='17' />
      </svg>
   )
}
export default IconFileText
